<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w Pos-r order_list">
        <div class="site-nav">
          <router-link :to="{name:'index'}">首页</router-link>>
          <router-link :to="{name:'user-center'}">个人中心</router-link>> 订单管理
        </div>
        <left-userinfo state="4"></left-userinfo>
        <div class="right_info_wrap">
          <div class="order-header clearfix">
            <div class="order-tab-title-list">
              <a
                href="javascript:void(0);"
                @click="switchTab(0)"
                class="order-tab-title"
                :class="{'selected':activeIndex[0]==0}"
              >
                <p>全部订单</p>
              </a>

              <a
                href="javascript:void(0);"
                @click="switchTab(1)"
                class="order-tab-title"
                :class="{'selected':activeIndex[0]==1}"
              >
                <p>
                  待支付(
                  <span style="color:#E2333F;" class="ng-binding">{{count}}</span> )
                </p>
              </a>

              <!-- <a
                href="javascript:void(0);"
                @click="switchTab(2)"
                class="order-tab-title"
                :class="{'selected':activeIndex[0]==2}"
              >
                <p>
                  未核销
                </p>
              </a> -->

              <!-- <a
                href="javascript:void(0);"
                @click="switchTab(3)"
                class="order-tab-title"
                :class="{'selected':activeIndex[0]==3}"
              >
                <p>
                  已核销
                </p>
              </a> -->
            </div>
            <!-- 订单搜索 -->
            <div class="order_info_search">
              <el-input class="order_search_text" v-model="keyword" placeholder="输入场馆名称或订单编号"></el-input>
              <i class="el-icon el-icon-mysearch" @click="order_search"></i>
            </div>
            <div style="clear:both;"></div>
          </div>

          <div class="user-order-content-wrapper" v-if="orderList && orderList.length>0">
            <table class="orderlist-title-wrapper">
              <tbody>
                <tr>
                  <td class="orderlist-title-name">订单商品</td>
                  <td class="orderlist-title-money">金额</td>
                  <td class="orderlist-title-status">全部状态</td>
                  <td class="orderlist-title-opt">操作</td>
                </tr>
              </tbody>
            </table>

            <div class="user-order-content" v-for="item in orderList" :key="item.id">
              <el-row class="title-info">
                <el-col :span="6">{{item.updated_at}}</el-col>
                <el-col :span="6">
                  订单编号:
                  <span>{{item.id}}</span>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>
              <table class="user-order-table">
                <tbody class="user-order-list">
                  <tr class="user-order-item">
                    <td class="user-order-name">
                      <el-row>
                        <el-col :span="10" class="user-order-product-title">
                          <img
                            alt="商品图片"
                            align="center"
                            :src="item.qu_yun_dong_order[0].venues_img_url?item.qu_yun_dong_order[0].venues_img_url:goodsDefault"
                          >
                          {{item.qu_yun_dong_order[0].venues_name}}
                        </el-col>
                        <el-col :span="3" class="user-order-product-count">{{item.qu_yun_dong_order[0] && item.qu_yun_dong_order[0].category.cat_name}}</el-col>
                        <el-col :span="3" class="user-order-product-list">
                          <div>{{item.qu_yun_dong_order[0].date | dateFormat3}}({{item.qu_yun_dong_order[0].date | dayFormat2}})</div>
                          <div v-for="i in item.qu_yun_dong_order" :key="i.id">
                            {{i.field_name}}：
                            <span>{{i.time}}-{{i.end_time}} {{i.price | intYuan}}</span>
                          </div>
                        </el-col>
                      </el-row>
                    </td>
                    <td style="color:#FC0010">{{item.total | yuan}}</td>
                    <td style="color:#FD6C17">{{item.status}}</td>
                    <td class="user-order-operation">
                      <div v-show="item.status_id==1">
                        <el-button
                          style="color:#FB6929;border-color:#FB6929"
                          @click.native="doPayNow(item.id)"
                        >立即支付</el-button>
                      </div>
                      <router-link :to="{name:'qyd-order-detail',params:{order_id:item.id}}">查看订单</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <el-pagination
            v-if="totalList>0"
            @current-change="handleCurrentChange"
            :page-size="4"
            layout="prev, pager, next, jumper"
            :total="totalList"
          ></el-pagination>
          <is-empty v-if="isEmpty"></is-empty>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
import IsEmpty from "@/components/is-empty";
import GOODSDEFAULT from "@/assets/images/goods_default.jpg";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo,
    IsEmpty
  },
  data() {
    return {
      keyword: "",
      activeIndex: [0],
      orderList: [],
      keyword: "",
      curPage: 0,
      goodsDefault: GOODSDEFAULT,
      isEmpty: false,
      totalList: 0,
      currentPage: 2,
      count:0,
      status :[0,1,2,3,4,5,]
    };
  },
  methods: {
    getData() {
      this.curPage++;
      let obj = {
        status: this.status,
        page: this.curPage,
        limit: 4
      };
      if (this.keyword) {
        obj.keyword = this.keyword;
      }
      console.log(obj);
      this.$reqGet("api/store/quyundong_order", obj).then(res => {
        let data = res.data;
        this.orderList = data.data;
        this.totalList = data.pagination.total;
        console.log(this.orderList);
        if (this.orderList.length == 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      });
      this.$reqGet('api/store/quyundong_order/orderCount',{status:[0]}).then(res=>{
        this.count = res.data.data.count;
      })
    },
    clearData() {
      this.orderList = [];
      this.curPage = 0;
    },
    switchTab(index) {
      console.log(index)
      if(index!=1){
        this.status = [0,1,2,3,4,5,]
      }else{
        this.status=[0]
      }
      this.activeIndex[0] = index;
      this.clearData();
      this.getData();
    },
    order_search() {
      this.clearData();
      this.getData();
    },
    doPayNow(id) {
      this.$router.push({
        name: "submit-order",
        params: { order_id: id }
      });
    },
    handleCurrentChange(val) {
      this.curPage = val - 1;
      this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="less" scoped>
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right_info_wrap {
  position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  left: 220px;
  box-sizing: border-box;
  padding: 22px 25px 60px;
  padding-bottom: 15px;
  background-color: #fff;
  .order-header {
    height: 37px;
    border-bottom: 2px solid #dadada;
    box-sizing: border-box;
    .order-tab-title-list {
      width: 700px;
      float: left;
      .order-tab-title {
        width: 135px;
        max-width: 135px;
        border-bottom: none;
        height: 30px;
        color: #666;
        text-align: center;
        padding-bottom: 5px;
      }
      p {
        display: inline-block;
        width: 100%;
        height: 18px;
        margin-top: 6px;
        line-height: 16px;
        font-size: 16px;
        border-right: 1px solid #bfbfbf;
        color: #999;
      }
      .selected {
        font-size: 14px;
        border-bottom: 2px solid #fd6e27;
        p {
          color: #e2333f;
          height: 20px;
          margin-top: 5px;
          line-height: 18px;
          font-size: 20px;
        }
      }
    }
    .order_info_search {
      float: right;
      width: 200px;
      height: 26px;
      line-height: 24px;
      padding: 2px 26px 2px 5px;
      border: 1px solid #e2e0dc;
      margin-top: -46px;
      position: relative;
      .order_search_text /deep/.el-input__inner {
        border: none;
        height: 26px;
        line-height: 26px;
        border-right: 1px solid #e2e0dc;
      }

      i {
        position: absolute;
        right: 5px;
        top: 6px;
        color: #6d6d6d;
        cursor: pointer;
      }
    }
  }
  .user-order-content-wrapper {
    min-height: 400px;
    .orderlist-title-wrapper {
      text-align: center;
      box-sizing: border-box;
      background-color: #fbfbfb;
      border: 1px solid #f5f5f5;
      margin: 20px 0;
      td {
        width: 162px;
        height: 40px;
        line-height: 40px;
        color: #222222;
      }
      .orderlist-title-name {
        width: 900px;
      }
    }
    .user-order-content {
      border: 1px solid #f5f5f5;
      margin-bottom: 10px;
      .title-info {
        background-color: #fbfbfb;
        padding: 10px 20px;
        overflow: hidden;
        color: #999;
        span {
          color: #222;
        }
      }
      .user-order-table {
        td {
          width: 120px;
          height: 105px;
          text-align: center;
          vertical-align: middle;
          border-left: 1px solid #f5f5f5;
          box-sizing: border-box;
        }
        .user-order-name {
          width: 670px !important;
          // display: block;
          box-sizing: border-box;
          padding-left: 10px;
          border-left: none;
          img {
            width: 60px;
            height: 60px;
            // margin-top: 10px;
          }
          .user-order-product-title {
            text-align: left;
            width: 250px;
            height: 57px;
            color: #222;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .user-order-product-count {
            line-height: 57px;
            color: #999;
          }
          .user-order-product-list {
            width: 200px;
            overflow: hidden;
            line-height: 26px;
          }
        }
        .user-order-operation {
          width: 120px;
          > div {
            margin: 8px;
          }
          .el-button {
            width: 70px;
            height: 26px;
            line-height: 26px;
            padding: 0;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(102, 102, 102, 1);
          }
          .cancel-btn:hover {
            color: #666;
          }
        }
        .times-td {
          line-height: 26px;
        }
      }
    }
  }
}
.el-pagination {
  padding: 10px 15px;
  text-align: right;
  font-weight: normal;
}
.right_info_wrap /deep/ .el-pager li {
  border: 1px solid #ddd;
  margin-right: 5px;
}
.right_info_wrap /deep/ .el-pager li.active {
  color: #fff;
  background-color: #e2333f;
  border: 1px solid #e2333f;
}
.right_info_wrap /deep/ .el-pager li:hover {
  color: #fff;
  background-color: #e2333f;
  border: 1px solid #e2333f;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/qyd-order-list.vue